import { AccountObjectFacade } from '../account-object/account-object.facade';
import { CategoryGroupApiFacade } from './category-group.api-facade';
import { CategoryGroup } from './category-group.model';
import { CategoryGroupStoreFacade } from './category-group.store-facade';

export class CategoryGroupFacade extends AccountObjectFacade<CategoryGroup, CategoryGroupApiFacade, CategoryGroupStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category-group/category-group.facade.ts